/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconHelp = createReactComponent("help", "IconHelp", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M12 17l0 .01", key: "svg-1" }],
  [
    "path",
    { d: "M12 13.5a1.5 1.5 0 0 1 1 -1.5a2.6 2.6 0 1 0 -3 -4", key: "svg-2" }
  ]
]);

export { IconHelp as default };
//# sourceMappingURL=IconHelp.js.map
